import { render, staticRenderFns } from "./EditFundingRounds.vue?vue&type=template&id=3ec9a68e&scoped=true"
import script from "./EditFundingRounds.vue?vue&type=script&lang=js"
export * from "./EditFundingRounds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../frontend-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec9a68e",
  null
  
)

export default component.exports